export default "__VITE_ASSET__5032f005__"